import * as React from 'react';
import { useInstantSearch } from 'react-instantsearch';
import '@grandvisionhq/analytics';
import '@grandvisionhq/state';
import '../../types.js';
import '../../Algolia/AlgoliaConfig.js';
import '@grandvisionhq/common';
import 'lodash/orderBy';
import '@grandvisionhq/forms';
import '@grandvisionhq/icons';
import 'classnames';
import 'lodash/uniqBy';
import '@grandvisionhq/elements';
import '@grandvisionhq/utils';
import 'motion/react';
import { SortBy } from '../../Algolia/components/SortBy/SortBy.js';
import '@swc/helpers';
import 'algoliasearch/lite';
import 'react-dom/server';
import 'lodash/merge';
import '../../Algolia/utils/query-string.js';
import '../../Algolia/AlgoliaDataProvider.js';
import '../../Algolia/AlgoliaAnalytics.js';
import '@grandvisionhq/products';
import '../../CrossSellProducts/utils/create-algolia-filters.js';
import { getResultsByIndex } from '../../Algolia/utils/get-results-by-index.js';

const SearchOrderBy = ({ amountOfHitsLabel , showSortBy , activeIndex , sortIndices  })=>{
    const { scopedResults  } = useInstantSearch();
    const suggestions = getResultsByIndex(scopedResults, (activeIndex === null || activeIndex === void 0 ? void 0 : activeIndex.name) || '');
    const amountOfHits = `${(suggestions === null || suggestions === void 0 ? void 0 : suggestions.nbHits) || 0} ${amountOfHitsLabel}`;
    if (!sortIndices.length || !sortIndices[0]) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__sort-results"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__amount-hits"
    }, amountOfHits), showSortBy && sortIndices && sortIndices.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__sort-by"
    }, /*#__PURE__*/ React.createElement(SortBy, {
        items: sortIndices
    })));
};

export { SearchOrderBy, SearchOrderBy as default };
//# sourceMappingURL=SearchOrderBy.js.map
